import DoneAllRoundedIcon from "@mui/icons-material/DoneAllRounded";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import { Box, Typography } from "@mui/material";
import type { JSX } from "react";

import { deliveryStatusLabel } from "./deliveryState.js";

/**
 * The explicit Sent / Delivered / Seen caption under my latest DM message.
 * The matching tick set rides alongside (single grey = sent, double grey =
 * delivered, double blue = seen) so the word and the icon always agree.
 */
export function DeliveryStatus({
  read,
  recipientOnline,
}: {
  read: boolean;
  recipientOnline: boolean;
}): JSX.Element {
  const status = deliveryStatusLabel(read, recipientOnline);
  return (
    <Box
      data-testid="chat-dm-status"
      data-status={status}
      sx={{ display: "flex", justifyContent: "flex-end", pr: 1.25, mt: 0.2 }}
    >
      <Typography
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.3,
          fontSize: 11,
          fontWeight: 600,
          color: read ? "chat.tickRead" : "chat.meta",
        }}
      >
        {status === "Sent" ? (
          <DoneRoundedIcon sx={{ fontSize: 14, color: "chat.tick" }} />
        ) : (
          <DoneAllRoundedIcon sx={{ fontSize: 14, color: read ? "chat.tickRead" : "chat.tick" }} />
        )}
        {status}
      </Typography>
    </Box>
  );
}
